export default i18n => ([
  {
    name: 'action',
    title: () => i18n.t('user-management.fields.action')
  },
  {
    name: 'avatar',
    title: () => i18n.t('user-management.fields.photo'),
    titleClass: 'text-center',
    dataClass: 'text-center'
  },
  {
    name: 'isActive',
    title: () => i18n.t('user-management.fields.active'),
    titleClass: 'text-center',
    dataClass: 'text-center',
    sortField: 'isActive'
  },
  {
    name: 'comorbid',
    title: () => i18n.t('user-management.fields.comorbid'),
    titleClass: 'text-center',
    dataClass: 'text-center',
    sortField: 'comorbid'
  },
  {
    name: 'isActiveDirectory',
    title: () => i18n.t('user-management.fields.hris-status'),
    dataClass: 'text-nowrap',
    sortField: 'hrisStatus'
  },
  {
    name: 'fullname',
    title: () => i18n.t('user-management.fields.fullname'),
    sortField: 'fullname'
  },
  {
    name: 'email',
    title: () => i18n.t('user-management.fields.email'),
    dataClass: 'text-nowrap',
    sortField: 'email'
  },
  {
    name: 'workUnit',
    title: () => i18n.t('user-management.fields.department'),
    sortField: 'workUnit'
  },
  {
    name: 'company.name',
    title: () => i18n.t('user-management.fields.company')
  }
])
